<template>
  <NonScDrawer :open="drawer.open" @closed="() => (drawer.open = false)">
    <template slot="body">
      <div class="editor-header">
        <h4 class="editor-title">
          {{ title }}
        </h4>
      </div>

      <div class="editor">
        <div v-if="mode == 'create'" class="editor-form">
          <div class="group">
            <el-button
              v-for="(option, i) in options"
              :key="i"
              :type="'sc-asset'"
              :inactive="creator != option.value"
              @click="() => (creator = option.value)"
            >
              {{ option.name }}
            </el-button>
          </div>
        </div>

        <div v-if="mode != 'update-user'" class="editor-form">
          <div>
            <label>
              <i v-if="valid.role" class="el-icon-circle-check valid" />
              <i v-else class="el-icon-warning invalid" /> สถานะ
            </label>
            <br />
            <div class="group">
              <el-button
                v-for="(option, i) in role"
                :key="i"
                :type="'sc-asset'"
                :inactive="input.role != option.value"
                @click="() => (input.role = option.value)"
              >
                {{ option.name }}
              </el-button>
            </div>
          </div>
        </div>

        <div v-if="creator == 'ADD'" class="editor-form" style="gap: 0">
          <label> เลือกลูกบ้าน </label>
          <NonScUserSelector @select="(value) => select(value)" />
        </div>

        <div v-if="creator == 'NEW'" class="editor-form">
          <div class="form grid-2">
            <div>
              <label>
                <i v-if="valid.firstName" class="el-icon-circle-check valid" />
                <i v-else class="el-icon-warning invalid" /> ชื่อจริง
              </label>
              <input
                v-model="input.firstName"
                :placeholder="'ระบุชื่อจริง'"
                type="text"
                name="firstName"
                class="input el-input__inner"
              />
            </div>
            <div>
              <label>
                <i v-if="valid.lastName" class="el-icon-circle-check valid" />
                <i v-else class="el-icon-warning invalid" /> นามสกุล
              </label>
              <input
                v-model="input.lastName"
                :placeholder="'ระบุนามสกุล'"
                type="text"
                name="lastName"
                class="input el-input__inner"
              />
            </div>
          </div>

          <div class="form grid-2">
            <div>
              <label>
                <i v-if="valid.mobileNo" class="el-icon-circle-check valid" />
                <i v-else class="el-icon-warning invalid" /> เบอร์มือถือ
              </label>
              <input
                v-model="input.mobileNo"
                :placeholder="'ระบุเบอร์มือถือ'"
                type="text"
                name="mobileNo"
                class="input el-input__inner"
              />
              <p class="hint subtitle">
                เบอร์มือถือต่างประเทศต้องขึ้นต้นด้วย +
              </p>
            </div>
            <div>
              <label>
                <i
                  v-if="input.email && valid.email"
                  class="el-icon-circle-check valid"
                />
                <i v-else-if="input.email" class="el-icon-warning invalid" />
                อีเมล์
              </label>
              <input
                v-model="input.email"
                :placeholder="'ระบุอีเมล์'"
                type="text"
                name="email"
                class="input el-input__inner"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="editor-action group">
        <el-button
          :disabled="!allow"
          class="action"
          type="sc-asset"
          @click="() => submit()"
        >
          บันทึก
        </el-button>
        <el-button
          v-if="mode == 'update' || mode == 'update-user'"
          class="action"
          type="danger"
          @click="() => remove()"
        >
          ลบลูกบ้าน
        </el-button>
        <el-button
          class="action"
          type="info"
          @click="() => (drawer.open = false)"
        >
          ยกเลิก
        </el-button>
      </div>
    </template>
  </NonScDrawer>
</template>

<script lang="js">
// Components
import NonScDrawer from "../../components/NonScDrawer"
import NonScUserSelector from "../../components/NonScUserSelector"

// Common
import { NonScCommon as Common } from "../../common/nonsc.common"

import { NonScUserCommon as UserCommon } from "../../common/nonsc-user.common"

// Utils
import { ValidateUtility as Validate } from "../../utils/validate"

import {
  display,
  isValidNewInput,
  normalize
} from '../../utils/phone'

export default {
  components: {
    NonScDrawer,
    NonScUserSelector,
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    mode: {
      type: String,
      default: "create",
    },
    form: {
      type: Object,
      default: () => UserCommon.input,
    },
  },
  data() {
    return {
      creator: "NEW",
      options: [
        { name: "สร้างใหม่", value: "NEW" },
        { name: "ลูกบ้านที่มีอยู่", value: "ADD" },
      ],
      drawer: {
        open: false,
      },
      input: { ...UserCommon.input },
    }
  },
  computed: {
    title() {
      return this.mode === "create"
        ? "เพิ่มข้อมูลลูกบ้าน"
        : "แก้ไขข้อมูลลูกบ้าน"
    },
    role() {
      return Common.role
    },
    mobileNoUnchanged() {
      return (
        this.mode !== "create" &&
        !!this.form.mobileNo &&
        this.input.mobileNo === display(this.form.mobileNo)
      )
    },
    valid() {
      // Validator
      const valid = {
        email: false,
        firstName: false,
        lastName: false,
        mobileNo: false,
        role: false,
      }

      // Validate Input
      if (!this.input) return valid

      // Input Props
      const { firstName, lastName, mobileNo, email, role } = this.input

      // Validate Role
      valid.role = !!role && Validate.isRole(role)

      // Validate Name
      valid.firstName = !!firstName && Validate.isName(firstName)
      valid.lastName = !!lastName && Validate.isName(lastName)

      // Validate Mobile Number
      valid.mobileNo =
        this.mobileNoUnchanged || (!!mobileNo && isValidNewInput(mobileNo))

      // Validate Email
      valid.email = email ? Validate.isEmail(email) : true

      return valid
    },
    allow() {
      // NOTE: create-role exempts only mobileNo, so a legacy 66-number can still be linked to a home.
      if (this.mode === "create" && this.creator === "ADD") {
        return this.allowRole
      }

      return Object.values(this.valid).every((e) => e)
    },
    allowRole() {
      const { mobileNo, ...valid } = this.valid

      return Object.values(valid).every((e) => e)
    },
  },
  watch: {
    form: {
      handler(value) {
        this.setInput(value)
      },
      deep: true,
    },
    open(value) {
      // Validate State
      if (!value) return

      // Set Drawer
      this.drawer.open = value

      // Set Input
      if (value) {
        this.setInput(this.form)
      } else {
        setTimeout(this.setInput, 400)
      }

      // Reset Creator
      this.creator = "NEW"
    },
    "drawer.open": function drawerOpenWatcher(open) {
      if (!open) this.$emit("closed")
    },
    creator() {
      this.setInput()
    },
  },
  mounted() {
    // Set Drawer
    this.drawer.open = this.open

    // Set Form
    this.setInput(this.form)
  },
  methods: {
    setInput(value = { role: "OWNER" }) {
      // Input Name
      const keys = Object.keys(UserCommon.input)

      // Map Input
      const form = keys.reduce((e, key) => ({ ...e, [key]: value[key] }), {})

      // Set Input
      this.input = { ...UserCommon.input, ...form }

      // Input Props
      const { mobileNo } = this.input

      // Set Mobile Number
      if (mobileNo) {
        this.input.mobileNo = display(mobileNo)
      }
    },
    select(input) {
      // Validate Input
      if (!input) return

      // Input Key
      const keys = ["firstName", "lastName", "mobileNo", "email"]

      // Set Input
      keys.forEach((e) => {
        this.input[e] = input[e]
      })
    },
    create() {
      // Create Handler
      switch (this.creator) {
        case "NEW":
          this.$emit("create-user", {
            ...this.input,
            mobileNo: normalize(this.input.mobileNo),
          })
          break
        case "ADD":
          this.$emit("create-role", this.input)
          break
        default:
          break
      }
    },
    remove() {
      // Emit Remove
      this.$emit("remove-user", this.input)

      // Set Drawer
      this.drawer.open = false
    },
    submit() {
      // Mode Handler
      switch (this.mode) {
        case "create":
          this.create()
          break
        case "update":
        case "update-user":
          this.$emit("update-user", {
            ...this.input,
            mobileNo: this.mobileNoUnchanged
              ? normalize(this.input.mobileNo) || this.form.mobileNo
              : normalize(this.input.mobileNo),
          })
          break
        default:
          break
      }

      // Set Drawer
      this.drawer.open = false
    },
  },
}
</script>

<style lang="css" scoped>
.hint {
  margin: 0.35rem 0 0;
  font-size: 0.8rem;
  font-style: italic;
  line-height: 1.4;
}

.drawer-body {
  display: flex;
  flex-direction: column;
  height: 100svh;
}

.editor {
  display: grid;
  gap: var(--size-sm);
  overflow-x: hidden;
  overflow-y: auto;
}

.editor-header,
.editor-action {
  padding: var(--size-lg);
}

.editor-title {
  margin: 0;
}

.editor-form {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: var(--size-sm);
  padding: 0 var(--size-lg);
}

.editor-action {
  display: flex;
}

.group {
  display: flex;
  gap: var(--size-xs);
  flex-wrap: wrap;
}

.editor-action.group {
  gap: var(--size-md);
}

.el-button.action {
  min-width: 5rem;
}

@media screen and (max-width: 768px) {
  .editor-header,
  .editor-action {
    padding: var(--size-md);
  }

  .editor-form {
    padding: 0 var(--size-md);
  }

  .editor-title {
    text-align: right;
  }
}
</style>
